import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const SendEmailSupportSlice = createSlice({
    name: 'SendEmailSumpport',
    initialState: null,
    reducers: {}
})
export const deleteEmailSupportNumber = (payload?: any): AppThunk<any> => async (dispatch) => {
    try {
        const response = await api.post(API_URL.SEND_EMAIL_SUPPORT.DELETE, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export const getEmailSupportList = (payload?: any): AppThunk<any> => async () => {
    try {
        const response = await api.post(API_URL.SEND_EMAIL_SUPPORT.LIST, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export const getEmailSupportViewStatusList = (payload?: any): AppThunk<any> => async () => {
    try {
        const response = await api.post(API_URL.SEND_EMAIL_SUPPORT.VIEW_STATUS, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export const getEmailSupportViewStatusLog = (payload?: any): AppThunk<any> => async () => {
    try {
        const response = await api.post(API_URL.SEND_EMAIL_SUPPORT.LOG_STATUS, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export const updateEmailSupportStatus = (payload?: any): AppThunk<any> => async () => {
    try {
        const response = await api.post(API_URL.SEND_EMAIL_SUPPORT.UPDATE_STATUS, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export const getProviderList = (): AppThunk<any> => async () => {
    try {
        const resp = await api.get(API_URL.SEND_EMAIL_SUPPORT.ALL_PROVIDERS)
        return Promise.resolve(resp.data)
    } catch (e: any) {
        return Promise.reject(e.data)
    }
}


export default SendEmailSupportSlice.reducer